import { useEffect, useState } from "react";
import { MiInputMultiSelectBox, MiModal } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  ENTITY_NAMES,
} from "@miplatform/constants";

export const ManageOrderTemplatesModal = ({
  open,
  orderTemplates,
  selectedData,
  loading,
  onModalClose,
  onSubmit,
}) => {
  const [selectedOrderTemplates, setSelectedOrderTemplates] = useState([]);

  const handleSubmit = () =>
    onSubmit({
      ...selectedData,
      orderTemplateIds: selectedOrderTemplates,
    });

  useEffect(() => {
    setSelectedOrderTemplates(
      selectedData?.orderTemplates?.map(({ id }) => id) || []
    );
  }, [selectedData, setSelectedOrderTemplates]);

  return (
    <MiModal
      title="Manage Products"
      open={open}
      loading={loading}
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          size: "medium",
          color: BUTTON_COLORS.BLACK,
          onClick: onModalClose,
        },
        {
          name: "Submit",
          variant: BUTTON_VARIANTS.CONTAINED,
          size: "medium",
          color: BUTTON_COLORS.PRIMARY,
          disabled: loading,
          onClick: handleSubmit,
        },
      ]}
      closeModal={onModalClose}
    >
      <MiInputMultiSelectBox
        disableNone
        labelText={ENTITY_NAMES.ORDER_TEMPLATES}
        value={selectedOrderTemplates}
        menuItems={orderTemplates.map((orderType) => ({
          label: orderType.name,
          value: orderType.id,
        }))}
        handleChange={(event) => setSelectedOrderTemplates(event.target.value)}
      />
    </MiModal>
  );
};
